import { h } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import { formatMoney } from 'utils/storefront/format-resource';

const CartDiscountCode = ({ cart, enableDiscountCodes }) => {
  const [currentDiscountCode, setcurrentDiscountCode] = useState('');
  const discountCodes = cart?.state?.discount_codes || [];
  const cartDiscounts = cart?.state?.cart_level_discount_applications || [];

  const [errorMessage, setErrorMessage] = useState(false);

  const updateCartDiscounts = () => {
    const applicableDiscounts = discountCodes
      .filter((code) => code.applicable)
      .map((discountCode) => discountCode.code);

    if (
      currentDiscountCode &&
      !applicableDiscounts.includes(currentDiscountCode)
    ) {
      applicableDiscounts.push(currentDiscountCode);
    }

    cart.update({ discount: applicableDiscounts.join(',') });
  };

  const handleDiscountUpdate = (e) => {
    if (errorMessage) {
      setErrorMessage(false);
    }

    setcurrentDiscountCode(e.target.value);
  };

  useEffect(() => {
    const inApplicableDiscountCodes = discountCodes.filter(
      (code) => !code.applicable,
    );

    if (inApplicableDiscountCodes.length > 0) {
      setcurrentDiscountCode(inApplicableDiscountCodes[0].code);
      setErrorMessage(true);
    } else {
      setErrorMessage(false);
    }
  }, [discountCodes]);

  const getTotalDiscount = (discountCode) => {
    let discountAmount = 0;

    const cartDiscount = cartDiscounts.find(
      (discount) => discount.title === discountCode,
    );

    discountAmount = cartDiscount?.total_allocated_amount;

    // Check for line item level discounts if no cart level discount found
    if (!discountAmount) {
      discountAmount = cart?.state?.items.reduce((total, item) => {
        const appliedDiscount = item.line_level_discount_allocations.find(
          (allocation) =>
            allocation.discount_application?.title === discountCode,
        );
        return total + (appliedDiscount ? appliedDiscount.amount : 0);
      }, 0);
    }

    if (!discountAmount) return '';

    const totalDiscount = formatMoney({
      amount: discountAmount / 100,
    });

    return `- ${totalDiscount}`;
  };

  return (
    <div>
      {enableDiscountCodes ? (
        <form
          className="py-[20px]"
          onSubmit={(e) => {
            e.preventDefault();
            updateCartDiscounts(e);
          }}
        >
          <label className="sr-only" htmlFor="cart-discount-code">
            {window.TMW.Strings.cart.discountCode}
          </label>
          <div className="body-3 border border-1 px-2.5 py-3 h-[42px] mb-2.5 flex gap-x-2 items-center justify-between border-black focus:border-black [&:has(input:focus-visible)]:border-blue-500">
            <input
              id="cart-discount-code"
              type="text"
              className="h-auto w-full p-0 m-0 flex-1 focus:ring-0 border-0 focus:outline-none body-3"
              placeholder={window.TMW.Strings.cart.discountInputPlaceholder}
              value={currentDiscountCode}
              onChange={handleDiscountUpdate}
            />
            <button className="border border-b-1 border-transparent border-b-black body-3 leading-110">
              {window.TMW.Strings.cart.apply}
            </button>
          </div>

          {errorMessage && (
            <div>
              <p className="body-3 text-sale">
                {window.TMW.Strings.cart.discountErrorMessage}
              </p>
            </div>
          )}

          {discountCodes.length > 0 &&
            discountCodes.map((discountCode) => (
              <div key={discountCode.code} className="mt-2">
                {discountCode.applicable && (
                  <div className="flex justify-between py-2.5 px-3 body-3--medium bg-core-1">
                    <p>{discountCode.code}</p>
                    <p>{getTotalDiscount(discountCode.code)}</p>
                  </div>
                )}
              </div>
            ))}
        </form>
      ) : (
        <div className="my-[20px]">
          <div className="bg-core-0 text-center px-[20px] py-[10px]">
            {cartDiscounts?.length ? (
              cartDiscounts?.map((discount, index) => (
                <p
                  key={index}
                  className="text-[14px] leading-[140%] tracking-[0.025em] font-medium"
                >
                  {discount.title} {window.TMW.Strings.cart.applied}
                </p>
              ))
            ) : (
              <p className="text-[14px] font-normal leading-[140%] tracking-[0.025em]">
                {window.TMW.Strings.cart.promo}
              </p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default CartDiscountCode;
